import newsieLogo from "Assets/newsie-triumphant-192-removebg.png";
import wordsearchLogo from "Assets/Games/wordsearch-logo.png";
import quizLogo from "Assets/Games/quiz.png";
import crossswordLogo from "Assets/Games/crossword-logo.png";

import "./GameType.css";

const gameToAssetMap = {
  newsie: {
    title: "Newsie",
    logo: newsieLogo,
  },
  wordsearch: {
    title: "Wordsearch",
    logo: wordsearchLogo,
  },
  crossword: {
    title: "Crossword",
    logo: crossswordLogo,
  },
  quiz: {
    title: "Quiz",
    logo: quizLogo,
  },
};

const GameType = (props) => {
  console.log('GameType props:', props);
  const { game } = props;
  if (!game) return null;
  const { title, logo } = gameToAssetMap[game];
  return (
    <div className="game-type-container">
      <div className="create-game-option-button-img-container">
        <img src={logo} style={{ width: '100px', height: "100px" }} />
      </div>
      <div className="create-game-option-button-label"><b>{title}</b></div>
    </div>
  );
};

export default GameType;